/**
 * Garde de route du back-office.
 *
 * Tant qu'aucun jeton n'est en mémoire, **aucun écran authentifié ne se monte** : on redirige vers
 * la connexion en mémorisant l'écran demandé. C'est la garantie qu'un refus `403 FORBIDDEN` à la
 * connexion ne laisse pas accéder à une liste de cartes vide mais rendue.
 */
import { Navigate, useLocation } from 'react-router-dom';

import { useSessionAdmin } from '../session/session-admin';

import type { ReactNode } from 'react';

export interface ProprietesGardeAdmin {
  readonly children: ReactNode;
}

export function GardeAdmin({ children }: ProprietesGardeAdmin) {
  const jeton = useSessionAdmin((etat) => etat.jeton);
  const emplacement = useLocation();
  if (jeton === null) {
    return <Navigate to="/connexion" replace state={{ depuis: emplacement.pathname }} />;
  }
  return <>{children}</>;
}
